"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DMSUpdateStrategy;
(function (DMSUpdateStrategy) {
    DMSUpdateStrategy["NONE"] = "NONE";
    DMSUpdateStrategy["KILL_REPLACE_START"] = "KILL_REPLACE_START";
})(DMSUpdateStrategy || (DMSUpdateStrategy = {}));
exports.default = DMSUpdateStrategy;
//# sourceMappingURL=DMSUpdateStrategy.js.map